import React from "react";

export default function MediaTags({ tags }) {
  return (
    <div>
      <p className="mb-[10px] mt-[30px] text-left font-outfit text-[14px] font-normal leading-[17.64px] text-[#666666]">
        Related Tags:
      </p>
      <p className="text-left font-outfit text-[16px] font-normal leading-[20.16px] text-[#222222]">
        {tags?.join(", ")}
      </p>
    </div>
  );
}
